import { Input } from "antd";
import { inject, observer } from "mobx-react";
import { Component } from "react";
import {
  Aside,
  AsideItem,
  ContainerWithAside,
  PublishActions,
  PublishSummary,
  ReleaseItemList,
} from "../../../components";
import { WithLoadingData } from "../../../hoc";
import withPublishToLiveStores from "../../../hoc/withPublishToLiveStores/withPublishToLiveStores";
import { InjectedProps, PublishProps } from "./PublishModel";

@inject("publishToLiveStore", "notificationStore")
@observer
class Publish extends Component<PublishProps, { searchValue: string | undefined }> {
  state = {
    searchValue: undefined,
  };
  get injected() {
    return this.props as InjectedProps;
  }

  initializePublishToLive = () => {
    return this.injected.publishToLiveStore.init();
  };

  filterReleaseItems: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    this.setState({ searchValue: event.target.value });
    this.injected.publishToLiveStore.filterReleaseItems(event.target.value);
  };

  render() {
    return (
      <WithLoadingData promise={this.initializePublishToLive}>
        <ContainerWithAside
          renderAside={() => (
            <Aside>
              <AsideItem header="Search">
                <Input
                  placeholder="Name or Public Id"
                  onChange={this.filterReleaseItems}
                  value={this.state.searchValue}
                />
              </AsideItem>
              <AsideItem header="Summary">
                <PublishSummary />
              </AsideItem>
              <AsideItem>
                <PublishActions />
              </AsideItem>
            </Aside>
          )}
        >
          <ReleaseItemList />
        </ContainerWithAside>
      </WithLoadingData>
    );
  }
}

export default withPublishToLiveStores(Publish);
